<div [class]="field.styleValue">
    <span class="text-value" [attr.lang]="metadataValue.language" [innerHTML]="metadataValue.value | dsEscapeHtml"></span>
</div>
